<script>
import MaterialBidForm from '@/components/exchange/material/MaterialBidForm.vue';
import MaterialBidTile from '@/components/exchange/material/MaterialBidTile.vue';

export default {
  name: 'MaterialBidList',
  components: { MaterialBidTile, MaterialBidForm },
  props: {
    items: Array,
    mainBid: Object,
  },
  data() {
    return {
      editableItem: null,
      isAdding: false,
    };
  },
  methods: {
    save(data) {
      this.$emit('create', data);
      this.isAdding = false;
    },
  },
};
</script>

<template lang="pug">
.material-bid-list
  template(v-for="item in items")
    MaterialBidForm(
      v-if="editableItem === item"
      :key="item.id"
      :item="item"
      @save="$emit('update', { ...$event, id: item.id })"
      @cancel="editableItem = null"
    )
    MaterialBidTile(
      v-else
      :key="item.id"
      :item="item"
      :checked="item.id === (mainBid && mainBid.id)"
      @check="$emit('select', item)"
      @edit="editableItem = item"
      @delete="$emit('delete', item)"
    )
  MaterialBidForm(v-if="isAdding" @save="save" @close="isAdding = false")
  Btn.button(lg dark v-else @click="isAdding = true")
    Icon(name="plus" pointer)
    | Добавить поставщика

</template>

<style scoped lang="scss">
.material-bid-list {
  position: relative;
  display: grid;
  padding: 26px 30px 26px 20px;
  gap: 15px;

  &:before {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 20px;
    background: #E0F0FF;
    border-radius:  0 0 10px 0;
  }
}

.button {
  justify-self: end;
  margin-right: 5px;
  margin-top: 15px;
}
</style>
